import { useLocation } from 'react-router';
import Canvas from '../../components/Canvas/Canvas';
import { AppStateProvider } from '../../context/AppState/AppState';
import { MouseEventsProvider } from '../../context/MouseEvents/MouseEvents';
import { useRoomId } from '../../hooks/useRoomId';

const ExportProject = () => {
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const exportToken = urlParams.get('token') || undefined;

  return (
    <div className="App">
      <AppStateProvider useRoomId={useRoomId} exportToken={exportToken}>
        <MouseEventsProvider>
          <Canvas />
        </MouseEventsProvider>
      </AppStateProvider>
    </div>
  );
};

export default ExportProject;
